import { EffectCallback, useEffect } from 'react';

/*

The same as componentDidMount

  useOnComponentMount(() => {
    console.log('Component ready');
  });

*/

export const useOnComponentMount = (onMountFn: EffectCallback) => {
  useEffect(() => onMountFn(), []);
};
